import get from "lodash/get";
import defaults from "lodash/defaults";
import React from "react";
import set from "@rill/set";
import ToggleLinksInput from "../../parts/inputs/toggle-links-input";
import ProfileModal from "../../parts/modals/profile";
import ReportsCoach from "./reports-coach";
import ReportsFe from "./reports-fe";

import { Parser } from "json2csv";
import AdminToggle from "./components/AdminToggle";
import { useRillContext } from "../../rill/RillReact/share/base";

function View(props) {
  const { locals } = useRillContext();

  const reports = locals.admin_royaltyReports;
  const { query } = locals;

  let coachesText = "Pull Coaches";

  if (query.reports === "coaches") {
    coachesText =
      coachesText + ` (${locals.coaches ? locals.coaches.coaches.length : 0})`;
  }

  return (
    <main className="admin">
      <AdminToggle />

      <div className="Reports-List">
        <div className="head">
          <ToggleLinksInput
            className="alt"
            name="reports"
            options={[
              { text: "Royalties", value: "royalties" },
              { text: "Sales Tax", value: "sales_tax" },
              {
                text: coachesText,
                value: "coaches",
              },
              {
                text: "Push Coaches",
                value: "pushCoaches",
              },
            ]}
          />
        </div>

        {query.reports === "coaches" && (
          <ReportsCoach
            coaches={locals.coaches.coaches}
            totalAthletes={locals.coaches.totalAthletes}
            totalAthletesActive={locals.coaches.totalAthletesActive}
            totalAthletesInactive={locals.coaches.totalAthletesInactive}
            momentTZ={locals.momentTZ}
            query={query}
          />
        )}

        {query.reports === "pushCoaches" && (
          <ReportsFe
            coaches={locals.coaches.coaches}
            totalSubscribers={locals.coaches.totalSubscribers}
            momentTZ={locals.momentTZ}
            query={query}
          />
        )}

        {locals.query.reports === "royalties" && (
          <div className="reports">
            {reports.map((report, i) => {
              return (
                <div className="report" key={i}>
                  <div className="date">
                    {locals.momentTZ(report.date).format("MMMM YYYY")}
                    {report.created &&
                      ` (Generated on ${locals
                        .momentTZ(report.created)
                        .format("Do MMMM YYYY")})`}
                  </div>
                  <a className="link" target="_blank" href={report.s3Path}>
                    Download
                  </a>
                </div>
              );
            })}
          </div>
        )}

        {locals.query.reports === "sales_tax" && (
          <div className="reports">
            <div className="report">
              <div className="date">Sales tax rate per user</div>
              <a
                className="link"
                href={`/api/sales-report?auth=${locals.user.token}`}
                target="_blank"
              >
                Download
              </a>
            </div>
          </div>
        )}
      </div>
    </main>
  );
}

const Reports = (app) => {
  app
    .use(set("heading", ["Admin", "Reports"]))
    .get("/reports", async ({ req, res, locals, load }) => {
      const { query } = req;
      const modal = get(query, "modal", {});
      locals.modal = {
        profile: <ProfileModal />,
      }[modal.type];

      defaults(query, {
        users: "all",
        reports: "royalties",
        adminToggle: "reports",
      });

      await load("admin_royaltyReports");
      if (query.reports === "coaches") {
        await load("coaches", {
          name: query.name,
          email: query.email,
          trialStatus: query.trialStatus,
          sortBy: query.sortBy,
          sortType: query.sortType,
        });

        if (query.csv) {
          const fields = [
            "_id",
            "name",
            "email",
            "active",
            "inactive",
            "totalAthletes",
            "trialStatus",
            "stripePlan",
            "daysLeft",
            "daysSince",
            "loggedIn",
          ];

          const json2csvParser = new Parser({ fields });
          const csv = json2csvParser.parse(locals.coaches.coaches);

          res.headers["Content-Disposition"] =
            "attachment; filename=" + "pull-coaches.csv";
          res.body = csv;
          return;
        }
      }

      if (query.reports === "pushCoaches") {
        await load("coaches", {
          name: query.name,
          email: query.email,
          onlyPush: true,
          sortBy: query.sortBy,
          sortType: query.sortType,
        });

        if (query.csv) {
          const fields = [
            "_id",
            "name",
            "email",
            "totalSubscribers",
            "loggedIn",
          ];

          const json2csvParser = new Parser({ fields });
          const csv = json2csvParser.parse(locals.coaches.coaches);

          res.headers["Content-Disposition"] =
            "attachment; filename=" + "push-coaches.csv";
          res.body = csv;
          return;
        }
      }

      res.body = <View />;
    });
};

export default Reports;
